import PropTypes from 'prop-types';
import React, { useState } from 'react';
import getFields from '../../../Helpers/getters';
import useDeleteEntity from '../../../Hooks/useDeleteEntity';
import DeleteConfirmModal from '../../Components/Delete/DeleteConfirmModal';
import DeleteEntityQuestion from '../../Components/Delete/DeleteEntityQuestion';
import Table from '../../Components/Table';

const Sublist = ({
    service,
    resource,
    entity,
    onDelete,
    overrideDelete,
    handleDelete,
    children,
    selectable,
    onSelectedChange,
}) => {
    const [fields] = useState(getFields(children));
    const {
        markedForDeletion,
        markForDeletion,
        clearMarkedForDeletion,
        confirmDelete,
        error,
        isDeleting,
    } = useDeleteEntity({
        service,
        resource,
        onSuccess: (deleted) => onDelete(deleted.id),
    });

    return (
        <>
            <Table
                entities={entity}
                fields={fields}
                data={{ resource, service }}
                remove={overrideDelete ? handleDelete : markForDeletion}
                selectable={selectable}
                onSelectedChange={onSelectedChange}
            />

            <DeleteConfirmModal
                isOpen={!!markedForDeletion}
                onRequestClose={clearMarkedForDeletion}
                onConfirm={confirmDelete}
                error={error}
                isDeleting={isDeleting}
            >
                {markedForDeletion && (
                    <DeleteEntityQuestion entity={markedForDeletion} />
                )}
            </DeleteConfirmModal>
        </>
    );
};

export default Sublist;

Sublist.propTypes = {
    /**
     * Type of service
     */
    service: PropTypes.object.isRequired,
    /**
     * Type of resource
     */
    resource: PropTypes.string.isRequired,
    /**
     * Type of entity
     */
    entity: PropTypes.object.isRequired,
    /**
     * Type of onDelete
     */
    onDelete: PropTypes.func,
    /**
     * Type of overrideDelete
     */
    overrideDelete: PropTypes.bool,
    /**
     * Type of handleDelete
     */
    handleDelete: PropTypes.func,
    /**
     * Type of selectable
     */
    selectable: PropTypes.bool,
    /**
     * Type of onSelectedChange
     */
    onSelectedChange: PropTypes.func,
    /**
     * Type of children
     */
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

Sublist.defaultProps = {
    onDelete: () => {},
    overrideDelete: false,
    handleDelete: () => {},
    selectable: false,
    onSelectedChange: () => {},
};
